import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation, useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { signOutUserStart } from '../../redux/User/user.actions';
import { selectCartItemsCount } from '../../redux/Cart/cart.selectors';
// import { selectWishItemsCount } from '../../redux/wishlist/wish.selectors';
import Logo from './../../assets/logo.png'

import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import Form from 'react-bootstrap/Form';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Image from 'react-bootstrap/Image'
import 'bootstrap/dist/css/bootstrap.min.css';

import * as Icon from 'react-feather';
import './styles.scss'

import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import { auth, firestore } from '../../firebase/utils';

const mapState = (state) => ({
  currentUser: state.user.currentUser,
  totalNumCartItems: selectCartItemsCount(state),
  // totalNumWishItems: selectWishItemsCount(state)
});

const Header = props => {

  const dispatch = useDispatch();
  const { currentUser, totalNumCartItems, totalNumWishItems } = useSelector(mapState);



  const signOut = () => {
    dispatch(signOutUserStart());
  };



  return (
    <>
      <Navbar collapseOnSelect expand="lg" sticky='top' >
        <Container>
          <Navbar.Brand href="/">
            <img src={Logo} alt='logo' className='logo' />
          </Navbar.Brand>
          <Nav.Link href="/cart" className="basket">

            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 54 64">
              <path d="M26.496 0h1.664c4.992 0.256 9.792 3.456 11.648 8.128 1.152 2.496 1.088 5.248 1.088 7.872 3.52 0 7.040 0 10.56 0 0.96 15.872 1.92 31.744 2.944 47.616v0.384h-54.4v-0.512c1.152-15.808 2.176-31.68 3.264-47.488 1.728 0 3.392 0 5.12 0 0 1.152 0 2.368 0 3.52 0.128 1.28-0.448 2.56-0.384 3.84-0.64 11.776-1.344 23.552-2.048 35.328 14.336 0 28.672 0 43.008 0-0.768-12.48-1.6-24.896-2.368-37.376-1.92 0-3.84 0-5.696 0 0 1.792 0 3.584 0 5.376-1.856 0-3.648 0-5.44 0 0-4.416 0-8.832 0-13.312 0-2.304-0.96-4.608-2.752-6.080-2.496-2.24-6.464-2.56-9.408-0.96-1.792 0.96-3.136 2.624-3.712 4.608-0.512 1.664-0.32 3.392-0.384 5.056 3.648 0 7.232 0 10.816 0 0 1.792 0 3.584 0 5.312-3.584 0-7.168 0-10.816 0 0 1.792 0 3.584 0 5.376-1.792 0-3.584 0-5.376 0 0-4.544-0.064-9.088 0-13.568 0-3.456 1.408-6.784 3.84-9.216 2.304-2.304 5.568-3.648 8.832-3.904z"></path>
            </svg>



            <span class="number">
              <span class="n-item">{totalNumCartItems}</span>
            </span>
          </Nav.Link>
          <Navbar.Toggle aria-controls="responsive-navbar-nav" />

          <Navbar.Collapse id="responsive-navbar-nav" >
            <Nav
              className="justify-content-end flex-grow-1 pe-3">
              <Nav.Link href="/" active={false}>About Us</Nav.Link>
              <Nav.Link href="/company">Gallery</Nav.Link>
              <Nav.Link href="/shop">Store</Nav.Link>
              <Nav.Link href="/contactus">Contact Us</Nav.Link>
            </Nav>

            {currentUser && [
              <Nav key={1}>
                <Nav.Link href="/myaccount" className='acct'>
                  <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="18" height="18" color='#ffffff' viewBox="0 0 59 64">

                    <path d="M28.224 0h2.496c4.544 0.256 9.088 1.984 12.48 5.056 5.568 4.928 8.256 13.056 6.336 20.288-1.216 4.864-4.416 9.024-8.384 12.032 6.4 2.944 12.16 7.744 15.040 14.272 1.728 3.712 2.56 7.744 2.88 11.776v0.576h-5.888c-0.064-5.568-2.112-11.2-5.824-15.36-4.864-5.568-12.416-8.576-19.776-7.872-7.296 0.576-14.144 4.864-18.176 11.008-2.368 3.584-3.328 7.936-3.52 12.224h-5.888v-0.64c0.384-4.032 1.216-8 2.88-11.712 2.88-6.528 8.64-11.328 15.040-14.272-6.144-4.16-9.536-11.776-8.832-19.072 0.704-9.728 9.472-17.792 19.136-18.304M26.304 6.208c-5.44 0.96-9.92 5.376-11.136 10.752-1.92 7.040 2.56 15.168 9.6 17.216 6.848 2.24 14.976-1.024 18.176-7.552 2.88-5.696 1.216-13.056-3.648-17.216-3.456-3.136-8.448-4.16-12.992-3.2z"></path>
                  </svg>
                </Nav.Link>

                <li key={2}>
                  <Button onClick={() => signOut()}>SIGNOUT</Button>
                </li>
              </Nav>,
            ]}

            {!currentUser && [
              <Nav key={1}>
                <Button variant="primary" href='/login' target='blank'>LOGIN</Button>
                <div className='mrg'></div>
                <Button variant="outline-primary" href='/register' target='blank'>SIGN UP</Button>
              </Nav>,
            ]}


          </Navbar.Collapse>



        </Container>
      </Navbar>
    </>
  );
};

Header.defaultProps = {
  currentUser: null
};

export default Header
